export function useMeta() {
  const { t } = useI18n()

  function addSuffix(title?: string | null | undefined): string | undefined {
    if (title === undefined || title === null) {
      return undefined
    }

    return title + ' ' + t('pages.meta.suffix')
  }

  function trimDescription(
    description?: string | null | undefined
  ): string | undefined {
    if (description === undefined || description === null) {
      return undefined
    }

    if (description.length <= 240) {
      return description
    }
    return description.substring(0, 240) + '...'
  }

  return {
    addSuffix,
    trimDescription,
  }
}
